export default __webpack_public_path__ + "static/media/search.61329981.svg";